import React from 'react';
import PropTypes from 'prop-types';
import './SocialLink.scss';

// TODO(WA-2177): fragno-button has no link mode, and the minimal footer only styles
// <fragno-button> social icons, so this is a real <a> styled with Nova tokens. Delete once
// fragno supports either.
const SocialLink = ({ href, icon, label }) => (
  <a className="fragno1-social-link" href={href} aria-label={label}>
    {icon}
  </a>
);

SocialLink.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default SocialLink;
